import { http } from './config'

export default {
    getAllList: (params) => {
        return http.get(`logs/listar?${params}`);
    }
}
